import React, { useEffect, useState } from "react";
import type { LeagueProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList, Image } from "react-native";
import { Icons, SearchBox } from "../../Components";
import { MarketComponentApi } from "../../MarketComponents/api";

type LeagueSelectorProps = {
    active_league_id?:string,
    onSelectLeague:(league:LeagueProps | undefined) => void
}
const LeagueSelector = ({ active_league_id, onSelectLeague }:LeagueSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);
    const [ leagues, setLeagues ] = useState<LeagueProps[]>([])
    const [ search, setSearch ] = useState('');

    const filtered_leagues = leagues.filter(pr => pr.league_name.toLowerCase().includes(search.toLowerCase())).slice(0,10)
    const active_league = leagues.find(l => l.league_id == active_league_id);

    useEffect(() => {
        getLeagues()
    },[]);
    
    const getLeagues = async() => {
        MarketComponentApi.setEnvironment();
        const leagues = await MarketComponentApi.getLeagues();
        setLeagues(leagues);
    }

    const renderLeagues = (data:{ item:LeagueProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectLeague(data.item) }}
            >
                <Image
                    source={{ uri: data.item.league_image }}
                    style={{ height: 35, width:35 }}
                    resizeMode="cover"
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.league_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.sport}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:15 }} float>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => { setVisible(!visible); onSelectLeague(undefined)}}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_league?.league_name ?? 'Select League'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <SearchBox
                onChange={(text) => setSearch(text)}
                hide_search_button
            />
            <FlatList
                data={filtered_leagues.sort((a,b) => a.status.localeCompare(b.status) ||a.priority - b.priority)}
                key={'league_selector'}
                keyExtractor={item => item.league_id.toString()}
                renderItem={renderLeagues}
            />
            </View>
            :<></>}
        </View>
    )
}

export default LeagueSelector